<template>
  <section class="fo-card">
    <div class="fo-card-loading loading loading-lg" v-if="loading"></div>
    <div class="fo-today-kpis">
      <div class="fo-today-main">
        <span class="fo-label">Resultado previsto do dia</span>
        <strong class="fo-hero fo-num" :class="{ 'is-negative': today.result < 0 }">
          {{ money(today.result) }}
        </strong>
        <span class="fo-hint">a receber menos a pagar com vencimento hoje</span>
      </div>
      <router-link class="fo-today-kpi" :to="route('revenue')">
        <span class="fo-label"><i class="fo-dot fo-dot-revenue"></i>A receber hoje</span>
        <strong class="fo-value fo-num">{{ money(today.receivable) }}</strong>
        <span class="fo-done" v-if="today.received > 0">
          <fa-icon :icon="['fal', 'check']"/>{{ money(today.received) }} já recebido hoje
        </span>
        <span class="fo-hint" v-else>nada recebido ainda hoje</span>
      </router-link>
      <router-link class="fo-today-kpi" :to="route('expense')">
        <span class="fo-label"><i class="fo-dot fo-dot-expense"></i>A pagar hoje</span>
        <strong class="fo-value fo-num">{{ money(today.payable) }}</strong>
        <span class="fo-done" v-if="today.paid > 0">
          <fa-icon :icon="['fal', 'check']"/>{{ money(today.paid) }} já pago hoje
        </span>
        <span class="fo-hint" v-else>nada pago ainda hoje</span>
      </router-link>
    </div>

    <div class="fo-card-head fo-due-head">
      <h2 class="fo-card-title">
        Vencendo hoje<small v-if="dueToday.total > 0">{{ dueToday.total }}</small>
      </h2>
      <router-link v-if="dueToday.total > 0" :to="route()">Ver na movimentação</router-link>
    </div>

    <div class="fo-rows" v-if="dueToday.items.length > 0">
      <div class="fo-line fo-line-due" v-for="item in dueToday.items" :key="item.id">
        <span>
          <span class="fo-pill"
                :class="item.type === 'revenue' ? 'fo-pill-revenue' : 'fo-pill-expense'">
            {{ item.type === 'revenue' ? 'A receber' : 'A pagar' }}
          </span>
        </span>
        <div class="fo-line-main">
          <strong>{{ item.name || 'Sem favorecido' }}</strong>
          <span :title="description(item)">{{ description(item) }}</span>
        </div>
        <span class="fo-line-value">{{ money(item.value) }}</span>
        <button type="button" class="btn btn-sm" :disabled="!canPay"
                @click="$router.push(`/financial/transactions/${item.id}/payment`)">Baixar</button>
      </div>
      <router-link class="fo-hint" v-if="dueToday.total > dueToday.items.length" :to="route()">
        e mais {{ dueToday.total - dueToday.items.length }} na movimentação
      </router-link>
    </div>
    <div class="fo-empty" v-else>
      <fa-icon :icon="['fal', 'check']"/>
      <strong>Nada vencendo hoje</strong>
      <span>Não há lançamentos em aberto com vencimento para hoje.</span>
    </div>
  </section>
</template>

<script>
import { PAY_FINANCIAL_TRANSACTION } from '@/data/actions/modules/financial';
import { money, transactionsRoute } from './helpers';

export default {
  props: {
    date: {
      type: String,
      required: true,
    },
    today: {
      type: Object,
      required: true,
    },
    dueToday: {
      type: Object,
      required: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    canPay() {
      return this.$can(PAY_FINANCIAL_TRANSACTION);
    },
  },
  methods: {
    money(value) {
      return money(value, this.hidden);
    },
    route(type) {
      return transactionsRoute({
        ...(type ? { type } : {}),
        startDate: this.date,
        endDate: this.date,
      });
    },
    description(item) {
      return [item.document, item.installment, item.category].filter(Boolean).join(' · ');
    },
  },
};
</script>
